// src/routes/__root.tsx
import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { AuthProvider } from "../context/AuthProvider";
import RouteSeo from '../components/RouteSeo';


export const Route = createRootRoute({
  component: () => {
    return (
      <AuthProvider>
        <RouteSeo />
        <Outlet /> {/* Child routes render here */}
        <TanStackRouterDevtools position="bottom-right" />
      </AuthProvider>
    )
  },
});
